export default "__VITE_ASSET__CpWFFUSd__"